import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getFunctions } from "firebase/functions"; // Unused
import { getStorage } from 'firebase/storage';
import config from './config/environment';

const firebaseConfig = {
  apiKey: config.firebase.apiKey,
  authDomain: config.firebase.authDomain,
  projectId: config.firebase.projectId,
  storageBucket: config.firebase.storageBucket,
  messagingSenderId: config.firebase.messagingSenderId,
  appId: config.firebase.appId,
  measurementId: "G-ZJZTSHFK7J" // This can stay hardcoded as it's not sensitive
};

// Initialize Firebase - only if not already initialized
let app;
try {
  const apps = getApps();
  if (apps.length === 0) {
    app = initializeApp(firebaseConfig);
  } else {
    app = apps[0];
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
  throw error;
}

// Initialize services
const auth = getAuth(app);

// Initialize Firestore
// Note: If you see QUIC_PROTOCOL_ERROR in console, those are usually transient network issues
// that Firestore handles automatically with retry logic. They don't affect functionality.
const db = getFirestore(app);
// const functions = getFunctions(app); // Unused
const storage = getStorage(app);



// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


export { app, auth, db, storage };
